/*
 * Created on Wed Oct 11 2023 4:46:23 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import { useSelector } from 'react-redux';

export const useCompanyContact = () => {
  const companyState = useSelector((state) => state?.companyReducer?.company) || {};
  
  const allowTransaction = companyState?.account?.allowTransaction || false;
  const contactPerson = companyState?.contactPerson || {};

  const contactEmail = contactPerson?.email;
  const contactPhone = contactPerson?.phoneNumber 
    ? `+${contactPerson?.countryCode || '1'} ${contactPerson?.phoneNumber}`
    : null;
  const contactName = contactPerson?.firstName && contactPerson?.lastName 
    ? `${contactPerson.firstName} ${contactPerson.lastName}`
    : 'Sales Team';

  const getButtonConfig = (defaultText = "Book Your Workspace", restrictedText = "Explore Spaces") => {
    return {
      text: allowTransaction ? defaultText : restrictedText,
      icon: allowTransaction ? 'arrow' : 'mail',
      isPaymentAllowed: allowTransaction
    };
  };

  return {
    allowTransaction,
    contactEmail,
    contactPhone,
    contactName,
    contactPerson,
    getButtonConfig
  };
};